/* Eiden — animaciones on-scroll ligeras (sin dependencias) */
(function () {
  'use strict';

  var prefersReduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(el) {
    el.classList.add('eiden-in');
  }

  function init() {
    // Auto-aplicar animación a las secciones de la home (sin tocar cada sección).
    if (document.body.classList.contains('template-index')) {
      var sections = document.querySelectorAll(
        '#MainContent > .shopify-section, #MainContent > section'
      );
      sections.forEach(function (sec, i) {
        // Saltar la primera (hero/slideshow): debe verse al instante.
        if (i === 0) return;
        if (!sec.hasAttribute('data-eiden')) {
          sec.setAttribute('data-eiden', 'up');
        }
      });
    }

    var nodes = document.querySelectorAll('[data-eiden]');
    if (!nodes.length) return;

    // Sin soporte o usuario que prefiere menos movimiento: mostrar todo ya.
    if (prefersReduced || !('IntersectionObserver' in window)) {
      nodes.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var delay = el.getAttribute('data-eiden-delay');
          if (delay) {
            el.style.transitionDelay = delay + 'ms';
          }
          reveal(el);
          io.unobserve(el);
        }
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.08
    });

    nodes.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
